import React from 'react';
import { NavLink } from './nav-link/NavLink';
import OzoneLogo from '@ozoneuniverse/ui-components/build-pkg/src/components/logo/OzoneLogo';
import { MenuDrawer } from './menu-drawer/MenuDrawer';
import { CDN_IMAGES_URL } from 'util/constants';
import styles from './navigation-bar.module.css';

export const NavigationBar = () => {
  return (
    <>
      <div className={styles.container}>
        <div className={styles.root}>
          <div className={styles.logoWrapper} data-cy='ozone-logo'>
            <OzoneLogo s3ImagesUrl={CDN_IMAGES_URL!} />
          </div>
          <div className={styles.col}>
            <div className={styles.linksWrapper}>
              <NavLink url='/' text='About' data-cy='nav-about' />
              <NavLink url='/agent3d' text='Agent 3D' data-cy='nav-agent3d' />
              <NavLink
                url='/create3d'
                text='Create 3D'
                data-cy='nav-create3d'
              />
              <NavLink url='/gaming' text='Gaming' data-cy='nav-gaming' />
            </div>
          </div>
          <div className={styles.menuDrawerWrapper}>
            <div data-cy='menu-drawer'>
              <MenuDrawer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
